var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ic-dialog',{ref:"dialog",staticClass:"ic-account-modal",class:{ 'ic-dialog--no-close': !_vm.allowClose },attrs:{"closed-by":_vm.allowClose ? 'any' : 'none'},on:{"close":_vm.handleClose}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }